export enum InsurerIdType {
  santam = 'SANTAM',
  absaplus = 'ABSAPLUS',
  miway = 'MIWAY',
  bryte = 'BRYTE',
  brolink10 = 'BROLINK10',
  absa = 'ABSA',
  absapremium = 'ABSAPREMIUM',
  kingprice = 'KINGPRICE',
  mutualFederal = 'MUTUAL&FEDERAL',
  peerless = 'PEERLESS',
  santamdirect = "SANTAMDIRECT",
}

export enum ScheduleStatusType {
  pendingEndorse = 'PENDING_ENDORSE',
  active = 'ACTIVE',
  endorsedAdded = 'ENDORSED_ADDED',
  endorsed = 'ENDORSED',
  inactive = 'INACTIVE',
  renewal = 'RENEWAL',
}
